import React from 'react';
import PropTypes from 'prop-types';
import { renderTimeTaken } from '../utility';
import withSubmissionData from 'legacy-src/utility/withSubmissionData';
import './styles.scss';

/**
 * Draws single student performance summary
 * */
const SingleStudentPerformanceSummary = (props) => {
  const {
    timeTakenData: { timer, timeTaken },
    studentMovedMessage,
  } = props;

  const showTimer = !!timer;

  return (
    <div className="SingleStudentSummaryByPart">
      <div className="SingleStudentSummaryByPart--left-container">
        {studentMovedMessage}
      </div>
      <div className="SingleStudentSummaryByPart--right-container">
        {showTimer && (
          <div className="SingleStudentSummaryByPart--timer">
            {renderTimeTaken(timer, timeTaken)}
          </div>
        )}
      </div>
    </div>
  );
};

SingleStudentPerformanceSummary.propTypes = {
  /**
   * Student Performance reports data
   * */
  learnosityReportsData: PropTypes.array.isRequired,
  /**
   * Context student id
   * */
  studentId: PropTypes.string.isRequired,
  timeTakenData: PropTypes.shape({
    /**
     * Assignment timer - if it's timed is sent
     * */
    timer: PropTypes.number,
    /**
     * Student time spent on the quiz
     * */
    timeTaken: PropTypes.number,
  }),
};

SingleStudentPerformanceSummary.defaultProps = {
  timeTakenData: {
    timer: null,
    timeTaken: 0,
  },
};

export default withSubmissionData(SingleStudentPerformanceSummary);
